import React, { } from "react";
import { useTranslation } from "react-i18next";

import { Divider } from '@lockerpm/design';

import {
} from "@ant-design/icons";

import commonComponents from "../../../components/common";
import securityComponents from "./components";

const Security = () => {
  const { PageHeader } = commonComponents;
  const {
    ChangeAccountPassword,
    ChangeMasterPassword,
    EncryptionKeySettings,
    TwoFA,
  } = securityComponents;
  const { t } = useTranslation();
  return (
    <div className="email-notifications layout-content">
      <PageHeader
        title={t('security.title')}
        subtitle={t('security.description')}
        actions={[]}
      />
      <ChangeAccountPassword className="mt-4"/>
      <Divider />
      <ChangeMasterPassword />
      <Divider />
      <EncryptionKeySettings />
      <Divider />
      <TwoFA />
      <Divider />
    </div>
  );
}

export default Security;